export default {
  getIsUseExportImportModule: "BackEnd/getIsUseExportImportModule",
  getExportImportModuleList: "BackEnd/getExportImportModuleList",
  setExportImportModule: "BackEnd/setExportImportModule",
  updateExportImportModule: "BackEnd/updateExportImportModule",
  deleteExportImportModule: "BackEnd/deleteExportImportModule",
};
